module.exports = __webpack_public_path__ + "img/kantar_ibope_color.cba7ebc9.svg";